import bannerOuvidoria from "./ouvidoria-banner.png";
import ouvidoriaSolicitarProtocolo from "./ouvidoria-solicitar-protocolo.svg";

const imagensPrevidencia = {
  bannerOuvidoria,
  ouvidoriaSolicitarProtocolo,
};

export default imagensPrevidencia;